const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverviewInflow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F0F6EF",
    style: {
      fill: "#F0F6EF",
      fill: "color(display-p3 0.9412 0.9647 0.9373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4521 23.4101C18.4521 24.5418 19.3272 25.4518 20.4005 25.4518H22.5938C23.5271 25.4518 24.2855 24.6584 24.2855 23.6668C24.2855 22.6051 23.8188 22.2201 23.1305 21.9751L19.6188 20.7501C18.9305 20.5051 18.4638 20.1318 18.4638 19.0584C18.4638 18.0784 19.2221 17.2734 20.1555 17.2734H22.3488C23.4221 17.2734 24.2972 18.1834 24.2972 19.3151",
    stroke: "#396C31",
    style: {
      stroke: "#396C31",
      stroke: "color(display-p3 0.2222 0.4235 0.1908)",
      strokeOpacity: 1
    },
    strokeWidth: 1.57895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3691 16.1184V26.6184",
    stroke: "#396C31",
    style: {
      stroke: "#396C31",
      stroke: "color(display-p3 0.2222 0.4235 0.1908)",
      strokeOpacity: 1
    },
    strokeWidth: 1.57895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0355 21.3683C33.0355 27.8083 27.8088 33.035 21.3688 33.035C14.9288 33.035 9.70215 27.8083 9.70215 21.3683C9.70215 14.9283 14.9288 9.70166 21.3688 9.70166",
    stroke: "#396C31",
    style: {
      stroke: "#396C31",
      stroke: "color(display-p3 0.2222 0.4235 0.1908)",
      strokeOpacity: 1
    },
    strokeWidth: 1.57895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2021 10.8684V15.5351H31.8688",
    stroke: "#396C31",
    style: {
      stroke: "#396C31",
      stroke: "color(display-p3 0.2222 0.4235 0.1908)",
      strokeOpacity: 1
    },
    strokeWidth: 1.57895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0355 9.70166L27.2021 15.535",
    stroke: "#396C31",
    style: {
      stroke: "#396C31",
      stroke: "color(display-p3 0.2222 0.4235 0.1908)",
      strokeOpacity: 1
    },
    strokeWidth: 1.57895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewInflow);
export default __webpack_public_path__ + "static/media/overview-inflow.545382351f2fc51c5c0154dd353cac9e.svg";
export { ForwardRef as ReactComponent };